import { makeObservable, observable } from 'mobx';
import { API } from '~/api';
import { ApiService } from '~/service/service.api';
import { DashboardService } from '~/service/service.dashboard';
import { Model } from '~/shared/service/service.base';
import { Async } from '~/shared/tools/async';

@Model()
export class DashboardFragrancesModel {
	readonly async = new Async();

	@observable.ref items: API.AnalyticsTopFragrancesItem[] = [];

	constructor(
		private api: ApiService,
		private dashboardSvc: DashboardService,
	) {
		makeObservable(this);
	}

	fetchData = (type: API.AnalyticsTopFragranceType) => {
		this.async.call(async () => {
			const { data } = await this.api.analyticsTopFragrances({ type, days: this.dashboardSvc.period });
			return () => {
				this.items = data.items;
			};
		});
	};
}
